import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Quote } from 'lucide-react'
import brochure from '../assets/docs/brochureComercialOlanAcademic.pdf'
import { generateProposalPDF } from '../lib/generateProposalPDF'
import signatureSrc from '../assets/img/firma-gustavo.png'
import './Trust.css'
import API from "../providers/api";

gsap.registerPlugin(ScrollTrigger)

const stats = [
  { num: 100, suffix: '+', label: 'Instituciones', desc: 'en COLOMBIA' },
  { num: 40, suffix: '%', label: 'Reducción de costos', desc: 'operativos promedio' },
  { num: 15, suffix: 'min', label: 'Tiempo de respuesta', desc: 'del soporte técnico' },
  { num: 99.9, suffix: '%', label: 'Uptime garantizado', desc: 'infraestructura en la nube' },
]

const logos = [
  'INSTITUCION EDUCATIVA NACIONALIZADO EL PASO - Cesar / El paso',
  'INSTITUCION EDUCATIVA EDGAR MORIN - Atlántico / Soledad',
  'FUNDACIÓN INSTITUTO DE FORMACIÓN Y DESARROLLO SOCIAL INFODES - Bolívar / Turbaco',
]

const testimonials = [
  {
    text: 'Desde que implementamos Olan Academic, reducimos el tiempo de generación de boletines de 3 días a 30 minutos. La plataforma es increíblemente intuitiva.',
    name: 'Jainer Rada',
    role: 'Rector',
    school: 'Institución Educativa Nacionalizado El Paso - Cesar / El paso',
  },
  {
    text: 'Los reportes académicos son impresionantes. La plataforma es muy intuitiva y rápida, esto nos ayuda a la toma de desiciones pedagógicas basadas en datos en tiempo real.',
    name: 'Domingo Jesus Berrio Ramirez',
    role: 'R. Legal',
    school: 'Fundación Instituto de Formación y Desarrollo Social INFODES - Bolívar / Turbaco',
  },
  {
    text: 'La implementación fue rápida y el soporte excepcional. Nuestra comunidad educativa ya estaba usando la plataforma una vez tuvimos los accesos al sistema.',
    name: 'Mirtha Causil Montiel',
    role: 'Rector',
    school: 'Institución Educativa Edgar Morin - Atlántico / Soledad',
  },
]

const AnimatedCounter = ({ target, suffix, duration = 2000 }) => {
  const [count, setCount] = useState(0)
  const ref = useRef(null)
  const hasAnimated = useRef(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true
            const start = Date.now()
            const step = () => {
              const elapsed = Date.now() - start
              const progress = Math.min(elapsed / duration, 1)
              const eased = 1 - Math.pow(1 - progress, 3)
              setCount(Number((eased * target).toFixed(target % 1 === 0 ? 0 : 1)))
              if (progress < 1) requestAnimationFrame(step)
            }
            requestAnimationFrame(step)
          }
        })
      },
      { threshold: 0.5 }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [target, duration])

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  )
}

const Trust = () => {
  const sectionRef = useRef(null)
  /* const logosRef = useRef(null) */
  const statsRef = useRef(null)
  const testimonialsRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      /* gsap.fromTo(
        logosRef.current.children,
        { opacity: 0, scale: 0.9 },
        {
          opacity: 0.6,
          scale: 1,
          duration: 0.5,
          stagger: 0.08,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: logosRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      ) */

      gsap.fromTo(
        statsRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: statsRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )

      if (testimonialsRef.current) {
        gsap.fromTo(
          testimonialsRef.current.children,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: testimonialsRef.current,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          }
        )
      }
    }, sectionRef)

    return () => ctx.revert()
  }, [])
  

  return (
    <section
      id="confianza"
      ref={sectionRef}
      className="section-padding"
      style={{ backgroundColor: 'white' }}
    >
      <div className="container-main" style={{ display: 'none' }}>
        {/* <div className="text-center mb-16">
          <div className="flex justify-center mb-4">
            <div
              className="flex items-center gap-2 px-4 py-2 rounded-full"
              style={{
                background: 'linear-gradient(135deg, rgba(16,185,129,0.15), rgba(15,41,62,0.1))',
                border: '1px solid rgba(16,185,129,0.3)',
              }}
            >
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path
                  d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6"
                  stroke="#10B981"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>

              <span style={{ color: '#10B981', fontWeight: 600, fontSize: 14 }}>
                Oferta por estudiante
              </span>
            </div>
          </div>

          <h2
            className="text-3xl md:text-[36px] font-bold"
            style={{ color: '#0F293E', lineHeight: 1.2 }}
          >
            VALOR DE COSTO POR ESTUDIANTE
          </h2>

          <div className="flex justify-center mt-6">
            <div
              className="relative px-10 py-6 rounded-2xl"
              style={{
                background: 'linear-gradient(135deg, #10B981 0%, #0F293E 100%)',
                boxShadow: '0 10px 30px rgba(16,185,129,0.25)',
                animation: 'pulseSoft 2.5s infinite ease-in-out',
              }}
            >
              <span
                className="text-4xl md:text-5xl font-extrabold"
                style={{ color: 'white' }}
              >
                $20.000
              </span>
              <p
                className="text-sm mt-1"
                style={{ color: 'rgba(255,255,255,0.8)' }}
              >
                por estudiante / año
              </p>

              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '16px',
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.15), transparent)',
                  pointerEvents: 'none',
                }}
              />
            </div>
          </div>

          <p
            className="mt-6 text-base mx-auto"
            style={{
              color: '#4B5563',
              lineHeight: 1.6,
              maxWidth: 640,
            }}
          >
            Y transforma toda la gestión académica
            y administrativa de tu colegio.
          </p>
        </div> */}

        {/* Logos Grid */}
         {/* <div className="text-center">
            <span
            className="badge-pill"
            style={{
              backgroundColor: 'rgba(16,185,129,0.1)',
              color: '#10B981',
              fontSize: '12px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            INSTITUCIONES QUE CONFIAN EN OLAN ACADEMIC
          </span> */}
            {/* <div
              ref={logosRef}
              className="grid grid-cols-2 md:grid-cols-3 gap-6"
            >
              {logos.map((name) => (
                <div
                  key={name}
                  className="flex items-center justify-center rounded-xl h-20 transition-all duration-300 cursor-default hover:scale-[1.02]"
                  style={{
                    backgroundColor: '#F3F4F6',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#E5E7EB'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#F3F4F6'
                  }}
                >
                  <span
                    className="font-semibold text-sm text-center px-4"
                    style={{ color: 'black' }}
                  >
                    {name}
                  </span>
                </div>
              ))}
            </div> */}
            {/* Testimonials */}
        {/* <div className="mt-2">
          <h3
            className="text-center text-2xl md:text-[28px] font-bold mb-12"
            style={{ color: '#0F293E' }}
          >
            Lo que dicen nuestros clientes
          </h3>

          <div
              ref={testimonialsRef}
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
            >
              {testimonials.map((t) => (
                <div
                  key={t.name}
                  className="rounded-2xl p-8"
                  style={{
                    backgroundColor: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                  }}
                >
                  <Quote size={32} color="#10B981" style={{ opacity: 0.3 }} />
                  <p
                    className="mt-4 text-base leading-relaxed"
                    style={{ color: '#374151', lineHeight: 1.7 }}
                  >
                    {t.text}
                  </p>
                  <div
                    className="mt-6 pt-5"
                    style={{ borderTop: '1px solid #E5E7EB' }}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className="flex items-center justify-center rounded-full text-white font-bold text-base"
                        style={{
                          width: 48,
                          height: 48,
                          background: 'linear-gradient(135deg, #10B981 0%, #0F293E 100%)',
                          display: 'none'
                        }}
                      >
                        {t.name.split(' ').map((n) => n[0]).join('')}
                      </div>
                      <div>
                        <p className="font-semibold text-[15px]" style={{ color: '#0F293E' }}>
                          {t.name}
                        </p>
                        <p className="text-sm" style={{ color: '#6B7280' }}>
                          {t.role}, {t.school}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
         {/* </div> */}
        

        {/* Stats Bar */}
        <div
          ref={statsRef}
          className="mt-16 rounded-2xl p-10 md:p-12"
          style={{ backgroundColor: '#0F293E' }}
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p
                  className="text-4xl md:text-5xl font-extrabold"
                  style={{ color: '#10B981' }}
                >
                  <AnimatedCounter target={stat.num} suffix={stat.suffix} />
                </p>
                <p
                  className="mt-2 text-base font-semibold"
                  style={{ color: 'white' }}
                >
                  {stat.label}
                </p>
                <p
                  className="mt-1 text-sm"
                  style={{ color: 'rgba(255,255,255,0.6)' }}
                >
                  {stat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Descargar Cotización */}
        <div className="text-center mb-12 mt-12" id="descargar-cotizacion">
          <h2
            className="text-3xl md:text-[36px] font-bold"
            style={{ color: '#0F293E', lineHeight: 1.2 }}
          >
            CÓNOCE AÚN MÁS DE NUESTRO PRODUCTO
          </h2>
          <p
            className="mt-4 text-base mx-auto"
            style={{
              color: '#4B5563',
              lineHeight: 1.6,
              maxWidth: 640,
            }}
          >
            Tén ya a la mano la solución perfecta para tu colegio.
          </p>
        </div>
        <div
          className="flex items-center justify-center gap-4"
        >
          {/* <button
            onClick={() => {
              generateProposalPDF(signatureSrc)
            }}
            className="flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-base transition-all duration-300 ease-out cursor-pointer hover:scale-105 active:scale-95"
            style={{
              background: 'linear-gradient(135deg, #0F293E 0%, #1a3d52 100%)',
              color: 'white',
              boxShadow: '0 4px 15px rgba(15, 41, 62, 0.3)',
              border: 'none',
              opacity:1,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 12px 25px rgba(15, 41, 62, 0.4)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(15, 41, 62, 0.3)'
            }}
          >
            <span style={{ fontSize: 18, cursor:'pointer' }}>📄</span>
            PROPUESTA COMERCIAL
          </button> */}

          <button
            onClick={() => {
              const link = document.createElement('a')
              link.href = brochure
              link.download = 'Olan-Academic-Brochure.pdf'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }}
            className="flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-base transition-all duration-300 ease-out cursor-pointer hover:scale-105 active:scale-95"
            style={{
              background: 'linear-gradient(135deg, rgb(16, 185, 129) 0%, rgb(15, 41, 62) 100%)',
              color: 'white',
              boxShadow: '0 4px 15px rgba(15, 41, 62, 0.25)',
              border: 'none',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 12px 25px rgba(15, 41, 62, 0.35)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(15, 41, 62, 0.25)'
            }}
          >
            <span style={{ fontSize: 18 }}>📄</span>
             BROCHURE
          </button>
        </div>

        {/* <div
          className="flex items-center justify-center gap-4 mt-10">
            <button className="btn-primary">
                ✅ ACEPTA PROPUESTA COMERCIAL
              </button>
        </div> */}

      </div>
    </section>
  )
}

export default Trust
